import expert from "./api/expertAPI";
const authGroup = "/auth";
export const LoginUrl = `${authGroup}/login`;

export const GetCasesUrl = `/employer/cases`;

const employerGroup = "/employer";
const employerUsercaseGroup = (case_id) => `${employerGroup}/case/${case_id}`;
const employerSponsorshipUsercaseGroup = (case_id) =>
  `${employerUsercaseGroup(case_id)}/sponsorship`;

export const GetEmployerSposorshipOverviewURL = (case_id) =>
  `${employerSponsorshipUsercaseGroup(case_id)}/overview`;
export const GetEmployerSposorshipOnlineApplicationURL = (case_id) =>
    `${employerSponsorshipUsercaseGroup(case_id)}/online_application`;
//employer candidate
const candidateGroup = (case_id) =>
  `${employerSponsorshipUsercaseGroup(case_id)}/candidate`;
export const GetEmployerSposorshipCandidateURL = (case_id) =>
  candidateGroup(case_id);
export const DeleteEmployerSposorshipCandidateURL = (case_id) =>
  candidateGroup(case_id);
export const InviteEmployerSposorshipCandidateURL = (case_id) =>
  candidateGroup(case_id);
export const FillInSelfEmployerSposorshipCandidateURL = (case_id) =>
  `${candidateGroup(case_id)}/self`;

const documentsGroup = (case_id) =>
  `${employerSponsorshipUsercaseGroup(case_id)}/documents`;
export const GetEmployerSposorshipDocumentsURL = documentsGroup;
export const UpdateEmployerSposorshipDocumentURL = documentsGroup;
const documentGroup = (case_id, doc_id) =>
  `${documentsGroup(case_id)}/${doc_id}`;
export const UploadEmployerSposorshipDocumentsURL = documentGroup;
export const AddCommentEmployerSponsorshipDocumentURL = (case_id, doc_id) =>
  documentGroup(case_id, doc_id) + "/comment";

const fileGroup = (case_id, doc_id, file_id) => `${documentGroup(case_id, doc_id)}/file/${file_id}`
export const DeleteFileURL = fileGroup

const flowGroup = "/flow";
export const GetParsedFlowsURL = flowGroup + "/parsed";
export const GetFlowListURL = flowGroup;

const userflowGroup = `${flowGroup}/userflow`;
const selectedUserflowGroup = (userflow_id) =>
  `${userflowGroup}/${userflow_id}`;

export const GetCurrentStepURL = (userflow_id) =>
  `${selectedUserflowGroup(userflow_id)}/current_step`;
export const AnswerStepURL = (userflow_id) =>
  `${selectedUserflowGroup(userflow_id)}/answer`;
export const GoStepBackURL = (userflow_id) =>
  `${selectedUserflowGroup(userflow_id)}/back`;

export const SearchJobTitlesURL = "/flow/search/job_titles";

export const expertAPI = expert;

export default "";
